import styled from 'styled-components';
export const success = 'success';
export const error = 'error';
export const warning = 'warning';

const getBorderColor = props => {
  switch (props.severity) {
    case success:
      return `border: 2px solid ${props.theme.palette.success.main};`;
      break;

    case error:
      return `border: 2px solid ${props.theme.palette.error.main};`;
      break;

    default:
      return `;`;
      break;
  }
};

export const SuggestBoxWrapper = styled.div.withConfig({
  displayName: "WrapperDiv__SuggestBoxWrapper",
  componentId: "sc-13gho0g-0"
})(["", " ", " text-align:", ";color:", ";"], props => getBorderColor(props), props => props.width ? `width: ${props.width}px;` : `width: 150px;`, props => props.textAlign ? props.textAlign : '', props => props.theme.palette.text.primary);
export const ExpandableSuggestBoxWrapper = styled.div.withConfig({
  displayName: "WrapperDiv__ExpandableSuggestBoxWrapper",
  componentId: "sc-13gho0g-1"
})(["", " ", " text-align:", ";color:", ";"], props => getBorderColor(props), props => props.width ? `min-width: ${props.width}px;` : `width: 150px;`, props => props.textAlign ? props.textAlign : '', props => props.theme.palette.text.primary);
export const ErrorText = styled.div.withConfig({
  displayName: "WrapperDiv__ErrorText",
  componentId: "sc-13gho0g-2"
})(["color:", ";margin:0;font-size:0.8rem;margin-top:3px;text-align:left;font-weight:400;line-height:1.66;"], props => props.theme.palette.error.main);
export const ErrorBoxWrapper = styled.div.withConfig({
  displayName: "WrapperDiv__ErrorBoxWrapper",
  componentId: "sc-13gho0g-3"
})(["margin-left:10px;color:", ";", ";"], props => props.theme.palette.error.main, props => props.width ? `width: ${props.width}px;` : `width: 150px;`);
export const StatementText = styled.div.withConfig({
  displayName: "WrapperDiv__StatementText",
  componentId: "sc-13gho0g-4"
})(["display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;padding:2px;"]);
export const VFStatementText = styled.div.withConfig({
  displayName: "WrapperDiv__VFStatementText",
  componentId: "sc-13gho0g-5"
})(["display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;padding:2px;min-height:36px;"]);
export const CreateOrderButtonsDiv = styled.div.withConfig({
  displayName: "WrapperDiv__CreateOrderButtonsDiv",
  componentId: "sc-13gho0g-6"
})(["display:flex;justify-content:space-around;padding-top:10px;padding-bottom:30px;"]);
export const OrderTypeStatement = styled(StatementText).withConfig({
  displayName: "WrapperDiv__OrderTypeStatement",
  componentId: "sc-13gho0g-7"
})(["margin-bottom:5px;font-weight:bold;"]);
export const OrderTypeWrapper = styled.div.withConfig({
  displayName: "WrapperDiv__OrderTypeWrapper",
  componentId: "sc-13gho0g-8"
})(["", " ", ""], props => getBorderColor(props), props => props.width ? `min-width: ${props.width}px;` : `width: 150px;`);
export const CPVFOrderConfirmation = styled.div.withConfig({
  displayName: "WrapperDiv__CPVFOrderConfirmation",
  componentId: "sc-13gho0g-9"
})([""]);
export const CPVFOrder = styled.div.withConfig({
  displayName: "WrapperDiv__CPVFOrder",
  componentId: "sc-13gho0g-10"
})([""]);